module.exports = __webpack_public_path__ + "post-listing-block-2-overlay-wide@2x-1ykDKsN.png";